import React, { FC, useMemo } from 'react';
import { Box, Typography } from '@mui/material';
import { ISinglePro } from './state';
import { SectionLabel } from './SectionCard';
import {
  getProfilePercentage,
  getFullProfilePercentage,
} from '../../pages/pro/createEditProfile/tabs';

const BLACK_FAMILY = 'CircularStdBlack, Helvetica, Arial, sans-serif';

/**
 * Internal-only profile-hygiene panel. Replaces the old unlabelled
 * CircularPercentage ring; never rendered for brand or anonymous viewers.
 * Shows the overall score plus the three lowest-scoring buckets.
 */
const InternalPanel: FC<{ expert?: ISinglePro }> = ({ expert }) => {
  const { overall, worst } = useMemo(() => {
    const buckets = getProfilePercentage(expert || {});
    return {
      overall: Math.round(getFullProfilePercentage(expert || {})),
      worst: Object.entries(buckets)
        .sort((a, b) => a[1] - b[1])
        .slice(0, 3),
    };
  }, [expert]);

  return (
    <Box className="bg-tint rounded-xl p-4 flex flex-col gap-3">
      <Box className="flex items-center justify-between gap-3">
        <SectionLabel>Internal only</SectionLabel>
        <Typography sx={{ fontFamily: BLACK_FAMILY, fontSize: 14, lineHeight: 1, color: 'var(--text)' }}>
          {overall}%
        </Typography>
      </Box>
      <Typography sx={{ fontSize: 12, lineHeight: 1.5, color: 'var(--text-2)' }}>
        Profile hygiene score. Not shown to brands.
      </Typography>
      <Box className="flex flex-col gap-1.5">
        {worst.map(([label, pct]) => (
          <Box key={label} className="flex items-center justify-between gap-3">
            <Typography sx={{ fontSize: 12, lineHeight: 1, color: 'var(--text)' }}>{label}</Typography>
            <Typography sx={{ fontSize: 12, lineHeight: 1, color: 'var(--text-2)' }}>
              {Math.round(pct)}%
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default InternalPanel;
